/**
 * Created by fers on 05.02.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';

export default class extends React.Component {
    static propTypes = {
        children: PropTypes.node,
		className: PropTypes.string,
        data: PropTypes.object.isRequired,
        metadata: PropTypes.object.isRequired,
        urlMapping: PropTypes.object.isRequired,
    };

    constructor() {
        super();
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    static contextTypes = {
        router: PropTypes.object
    };

    render() {
        return (
            <div className={"detailBox " + (this.props.className || '')}>
                {this.props.children}
            </div>
        );
    }
}
